module.exports = __webpack_public_path__ + "static/media/cancel-24px.b6512207.svg";